import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatHeader = _resolveComponent("ChatHeader")!
  const _component_ChatContent = _resolveComponent("ChatContent")!
  const _component_ChatReply = _resolveComponent("ChatReply")!
  const _component_ChatForm = _resolveComponent("ChatForm")!
  const _component_ChatFooter = _resolveComponent("ChatFooter")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col overflow-y-auto w-full webchat-shadow", _ctx.props.fixHeight ? 'h-[555px] rounded-md' : 'h-full'])
    }, [
      _createElementVNode("input", {
        type: "file",
        ref: "myFile",
        class: "hidden",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
      }, null, 544),
      _createVNode(_component_ChatHeader, {
        close: true,
        onCloseBox: _cache[1] || (_cache[1] = () => _ctx.emit("close-box"))
      }),
      _createVNode(_component_ChatContent),
      _createVNode(_component_ChatReply),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ChatForm, { "show-button": true }),
        _createVNode(_component_ChatFooter, {
          items: _ctx.actionsFooter,
          onUpdate: _ctx.handleAction
        }, null, 8, ["items", "onUpdate"])
      ])
    ], 2),
    (_ctx.modal.show)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          modelValue: _ctx.modal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal) = $event)),
          onOnUpdate: _ctx.handleModal
        }, null, 8, ["modelValue", "onOnUpdate"]))
      : _createCommentVNode("", true)
  ], 64))
}